const translate = require("../utils/translate");

// It's mandatory to initialize office addin
// https://learn.microsoft.com/en-us/office/dev/add-ins/develop/initialize-add-in#initialize-with-officeinitialize
Office.onReady();

const formatLanguage = function (language) {
  const baseLanguage = language.split("-")[0];

  let formatedLanguage = language;

  switch (baseLanguage) {
    case "es":
      formatedLanguage = "es_ES";
      break;
    case "fr":
      formatedLanguage = "fr_BE";
      break;
    case "nl":
      formatedLanguage = "nl_BE";
      break;
    default:
      formatedLanguage = "en_US";
  }

  return formatedLanguage;
};

async function getCalendarAddonInvitationsConfig() {
  const apiUrl = process.env.API_URL;
  const senderEmail = Office.context.mailbox.userProfile.emailAddress;

  try {
    const response = await fetch(
      apiUrl +
        "/calendar-add-on/invitations/config?" +
        new URLSearchParams({
          email: senderEmail,
        })
    );

    const calendarAddonInvitationsConfig = await response.json();

    // Temporary select the first organization, should be decide by the user
    const organizationId = calendarAddonInvitationsConfig[0].id;
    // For the moment we only support addin for single visitor portal setup per organization,
    // but the endpoint allready return all of them, so select the first one.
    const visitorPortalId = calendarAddonInvitationsConfig[0].visitor_portals[0].id;

    return {
      organizationId: organizationId,
      visitorPortalId: visitorPortalId,
    };
  } catch (error) {
    console.error(error);

    throw new Error(translate('an-error-occurred-please-contact-your-admin'));
  }
}

async function createVisitorPortalInvitation(organizationId, visitorPortalId) {
  const apiUrl = process.env.API_URL;
  const senderLanguage = Office.context.displayLanguage;
  const language = formatLanguage(senderLanguage);

  try {
    const response = await fetch(apiUrl + "/calendar-add-on/invitations", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        organization_id: organizationId,
        visitor_portal_id: visitorPortalId,
        language: language,
      }),
    });

    const { visitor_portal_invitation_id, visitor_portal_url } = await response.json();

    return {
      visitorPortalInvitationId: visitor_portal_invitation_id,
      visitorPortalUrl: visitor_portal_url,
    };
  } catch (error) {
    console.error(error);

    throw new Error(translate('an-error-occurred-please-contact-your-admin'));
  }
}

async function checkIfInvitationLinkIsAllreadyInTheBody() {
  return new Promise((resolve, reject) => {
    Office.context.mailbox.item.body.getAsync(Office.CoercionType.Html, function (result) {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        const bodyContent = result.value;
        const isInvitationLinkPresentInTheBody = bodyContent.includes("izix-visitor-portal-invitation-link");

        resolve(isInvitationLinkPresentInTheBody);
      } else {
        reject(new Error("Failed to get body content: " + result.error.message));
      }
    });
  });
}

function saveCustomPropertiesAsync(properties) {
  return new Promise((resolve, reject) => {
    Office.context.mailbox.item.loadCustomPropertiesAsync(async (asyncResult) => {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        const appointmentCustomSetting = asyncResult.value;

        for (const [key, value] of Object.entries(properties)) {
          appointmentCustomSetting.set(key, value);
        }

        await appointmentCustomSetting.saveAsync((saveResult) => {
          if (saveResult.status === Office.AsyncResultStatus.Failed) {
            reject(new Error(saveResult.error));
          } else {
            resolve();
          }
        });
      } else {
        reject(new Error(asyncResult.error));
      }
    });
  });
}

/**
 * Append a link to meeting body.
 * @param event {Office.AddinCommands.Event}
 */
async function addVisitorPortalInvitation(event) {
  const isLinkAllreadyPresent = await checkIfInvitationLinkIsAllreadyInTheBody();

  if (isLinkAllreadyPresent) {
    const message = {
      type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
      message: translate("visitor-portal-invitation-link-allready-present-error-label"),
      icon: "Icon.32x32",
      persistent: false,
    };

    Office.context.mailbox.item.notificationMessages.replaceAsync("action", message);

    event.completed();
    return;
  }

  try {
    const { organizationId, visitorPortalId } = await getCalendarAddonInvitationsConfig();

    const { visitorPortalUrl, visitorPortalInvitationId } = await createVisitorPortalInvitation(
      organizationId,
      visitorPortalId
    );

    await saveCustomPropertiesAsync({
      'visitorPortalInvitationId': visitorPortalInvitationId,
      'visitorPortalId': visitorPortalId
    });

    Office.context.mailbox.item.body.getAsync(Office.CoercionType.Html, function (asyncResult) {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        const currentBody = asyncResult.value;
        const newContent = translate('visitor-portal-invitation-body-content', {
          visitorPortalUrl: visitorPortalUrl
        })
        const updatedBody = currentBody + newContent;

        Office.context.mailbox.item.body.setAsync(
          updatedBody,
          { coercionType: Office.CoercionType.Html },
          function (asyncResult) {
            if (asyncResult.status === Office.AsyncResultStatus.Failed) {
              console.error(asyncResult.error.message);
            }

            event.completed();
          }
        );
      } else {
        console.error(asyncResult.error.message);
        event.completed();
      }
    });
  } catch (error) {
    const message = {
      type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
      message: error.message,
      icon: "Icon.32x32",
      persistent: false,
    };

    Office.context.mailbox.item.notificationMessages.replaceAsync("action", message);
    event.completed();
  }
}

Office.actions.associate("addVisitorPortalInvitation", addVisitorPortalInvitation);
